import { Badge, Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { AiAgents } from "@aircall/react-icons";
import { useIsTruncated } from "@/playground/components/DevHome/table/hooks/useIsTruncated/useIsTruncated";

type VirtualAgentTagProps = {
  name?: string;
  size?: Badge.Props["size"];
};

export function VirtualAgentTag({
  name,
  size = "default",
}: VirtualAgentTagProps) {
  // The Badge clips the name at `max-w-36`; measure the label so we only reveal
  // the full-name tooltip when it is actually cut off. We render our own
  // truncating span (matching the one the Badge auto-wraps bare text in) so the
  // ref lands on the element that ellipsis-clips.
  const { ref, isTruncated } = useIsTruncated<HTMLSpanElement>();

  const badge = (
    <Badge color="green" tone="medium-light" size={size}>
      <AiAgents />
      {Boolean(name) && (
        <span ref={ref} className="min-w-0 truncate">
          {name}
        </span>
      )}
    </Badge>
  );

  if (!name) {
    return badge;
  }

  return (
    <Tooltip>
      <TooltipTrigger render={badge} />
      {isTruncated && <TooltipContent>{name}</TooltipContent>}
    </Tooltip>
  );
}
